import { render, staticRenderFns } from "./OrgansSelect.vue?vue&type=template&id=e907245a&scoped=true&"
import script from "./OrgansSelect.vue?vue&type=script&lang=js&"
export * from "./OrgansSelect.vue?vue&type=script&lang=js&"
import style0 from "./OrgansSelect.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OrgansSelect.vue?vue&type=style&index=1&id=e907245a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e907245a",
  null
  
)

export default component.exports